export interface QuickBooksAccountConstructor {
  listId: string // QuickBooks ListID — selection key + import payload
  accountNumber: string // "Code" column
  accountType: string // "Type" column, rendered verbatim
  name: string
  description: string
}

export class QuickBooksAccount {
  readonly listId: string
  readonly accountNumber: string
  readonly accountType: string
  readonly name: string
  readonly description: string

  constructor(data: QuickBooksAccountConstructor) {
    this.listId = data.listId
    this.accountNumber = data.accountNumber
    this.accountType = data.accountType
    this.name = data.name
    this.description = data.description
  }
}
